export const dataMapRef = 'data-map';
